import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "../stores/authStore";
import { notificationService } from "../services/notificationService";

export const useBellCount = () => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery<number>({
    queryKey: ["bell-count"],
    queryFn: () => notificationService.getBellCount(),
    staleTime: 55 * 1000,
    refetchInterval: isAuthenticated ? 55 * 1000 : false,
    enabled: isAuthenticated,
  });
};
